import { useQuery } from "react-query";
import { getIdentityTypesForNonGemiRegistration } from "src/welcomeNonGemi/data-access/gateway";

export const useGetIdentityTypesForNonGemiRegistration = (enabled: boolean) => {
  return useQuery({
    queryFn: getIdentityTypesForNonGemiRegistration,
    queryKey: "getIdentityTypesForNonGemiRegistration",
    enabled: enabled,
  });
};
